export default __webpack_public_path__ + "static/media/layerRight1.c756f77b.webp";